import { render, staticRenderFns } from "./ColumnItem.vue?vue&type=template&id=61e5ded3&scoped=true&"
import script from "./ColumnItem.vue?vue&type=script&lang=js&"
export * from "./ColumnItem.vue?vue&type=script&lang=js&"
import style0 from "./ColumnItem.vue?vue&type=style&index=0&id=61e5ded3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5ded3",
  null
  
)

export default component.exports